import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-vip-diamond-line text-xl text-white"></i>
                </div>
                <span className="font-heading font-bold text-lg text-white">
                  {t('siteName')}
                </span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">
                {t('siteSlogan')}
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white mb-4 text-sm">
                {t('footerLinks')}
              </h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/lottery" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                  {t('navLottery')}
                </Link>
                <Link to="/articles" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                  {t('navArticle')}
                </Link>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                  {t('navAbout')}
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white mb-4 text-sm">
                {t('footerContact')}
              </h4>
              <div className="flex flex-col gap-2.5 text-foreground-400 text-sm">
                <div className="flex items-center gap-2">
                  <i className="ri-phone-line text-primary-500"></i>
                  <span>400-888-6666</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-500"></i>
                  <span>service@bbcaipiao.com</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-primary-500 mt-0.5"></i>
                  <span>广州市天河区珠江新城华夏路88号BB大厦28层</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white mb-4 text-sm">
                关注我们
              </h4>
              <div className="flex gap-3">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg text-white"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg text-white"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg text-white"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-foreground-500 text-xs">
              <p>{t('footerCopyright')}</p>
              <p className="text-center">{t('footerDisclaimer')}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}